import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NButtonModelCopy = _resolveComponent("NButtonModelCopy")!

  return (_openBlock(), _createBlock(_component_NButtonModelCopy, _mergeProps(_ctx.$props, {
    hint: _ctx.$t('common.make_copy')
  }), null, 16, ["hint"]))
}